// import { extendTheme } from "@chakra-ui/react";

// const theme = extendTheme({
//   styles: {
//     global: {
//       body: {
//         bg: "#1C1C1C",
//         color: "white",



//       },
//     },
//   },
//   // fonts: {
//   //   heading: "Cags Hetonal', sans-serif",
//   //   body: "Cags Hetonal', sans-serif",
//   // },

//   space: {
//     // Define your padding values here
//     padding: {
//       mobile: "10px",
//       desktop: "50px",
//     },
//     margin: {
//       mobile: "20px",
//       desktop: "100px",
//     },
//   },
//   components: {
//     header: {
//       baseStyle: {
//         padding: { base: "13px", md: "50px" },
//         margin: { base: "20px", md: "100px" },
//       },

//     Text: {
//       variants: {
//         customText: {
//           fontFamily: "'Cags Hetonal', sans-serif", // Custom font family
//           fontWeight: "400",
//         },
//         gilroy: {
//           fontFamily: "'Gilroy-SemiBold', sans-serif",
//           fontWeight: "400",
//         },
//         gilroyRegular: {
//           fontFamily: "'Gilroy-Regular', sans-serif", // New variant for Gilroy-Regular
//           fontWeight: "400",
//         },
//         gilroyMedium: {
//           fontFamily: "'Gilroy-Medium', sans-serif", // New variant for Gilroy-Regular
//           fontWeight: "400",
//         },
//         GilroyBold: {

//           fontFamily: "'Gilroy-Bold', sans-serif", // New variant for Gilroy-Regular
//           fontWeight: "400",
//         },
//       },
//     },
//   },

//   },
// });

// export default theme;


// theme.js
import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  initialColorMode: "dark", 
  useSystemColorMode: false, 
  colors: {
    transparent: "transparent",
    black: "#1C1C1C",
    white: "#fff",
    gray: {
      50: "#f7fafc",
      900: "#171923",
    },
    // Define additional colors here
  },
  styles: {
    global: {
      body: {
        bg: { light: "#ffffff", dark: "#1C1C1C" }, 
        color: { light: "black", dark: "white" },   
      },
    },
  },
  fonts: {
    heading: "'Cags Hetonal', sans-serif",
    body: "'Cags Hetonal', sans-serif",
  },
  space: {
    padding: {
      mobile: "10px",
      desktop: "50px",
    },
    margin: {
      mobile: "20px",
      desktop: "100px",
    },
  },
  components: {
    Text: {
      variants: {
        customText: {
          fontFamily: "'Cags Hetonal', sans-serif",
          fontWeight: "400",
        },
        gilroy: {
          fontFamily: "'Gilroy-SemiBold', sans-serif",
          fontWeight: "400",
        },
        gilroyRegular: {
          fontFamily: "'Gilroy-Regular', sans-serif",
          fontWeight: "400",
        },
        gilroyMedium: {
          fontFamily: "'Gilroy-Medium', sans-serif",
          fontWeight: "400",
        },
        GilroyBold: {
          fontFamily: "'Gilroy-Bold', sans-serif",
          fontWeight: "400",
        },
      },
    },
    header: {
      baseStyle: {
        padding: { base: "13px", md: "50px" },
        margin: { base: "20px", md: "100px" },
      },
    },
  },
});

export default theme;